import { useRouter } from 'next/router';
import { useEffect } from 'react';

/*
  This is a workaround for desktop and mweb's scroll restoration behaving erratically.

  TODO: this should be fixed on next.js level, but there's no apparent reason why it doesn't work as it should.
 */
export const useScrollToTopOnRouteChange = (isCordova: boolean) => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      if (isCordova || window.location.hash) return;
      // scroll to top if there is no expected initial scroll target
      window.scrollTo({ top: 0 });
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router, isCordova]);
};
